import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SCAMP_API } from 'src/environments/environment';
import { GrupoLocalNivel1 } from './../pages/domain/domain.model';
import { AccountService } from './account.service';



@Injectable({ providedIn: 'root' })
export class GrupolocalService {

  constructor(
    private http: HttpClient,
    private account: AccountService
  ) { }

  getAll(): Promise<GrupoLocalNivel1[]> {

    return fetch(`${SCAMP_API.accountApiV1}/gruposlocalnivel1`, {
      headers: {
          "Authorization": this.account.composeHeaders().keys["Authorization"]
      }
  }).then(res => res.json());

  }



}
